<template>
  <v-layout
    justify-end
    align-center
  >
    <span class="caption grey--text text--lighten-1 label-author">{{
      label.author | shortName
    }}</span>
    <v-menu
      ref="label-menu"
      menu-props="offsetY"
      :close-on-content-click="false"
      :disabled="canEdit"
    >
      <template v-slot:activator="{ on }">
        <v-chip
          text-color="white"
          label
          small
          :color="getColorForGroup(label.value[1], label.name)"
          v-on="user && !user.hasEmployee ? null : on"
          @click="
            user && !user.hasEmployee
              ? showInfo('Пользователь не привязан к сотруднику')
              : false
          "
        >
          {{ getVariantTitleForGroup(label.value[0], label.name) }}
        </v-chip>
      </template>

      <v-list>
        <v-list-tile
          v-for="(variant, index) in getAvailableVariantsForGroup(
            label.value[0],
            label.name
          )"
          :key="index"
          @click="changeLabel(variant.id, label.value[0], label.name, true)"
        >
          <v-list-tile-title>
            {{
              variant.description || variant.title
            }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-switch
            v-model="controlValue"
            hide-details
            :disabled="label.value[1].disabled"
            :label="`${getControlValueLabel(label.value[1], label.name)}`"
            @change="
              changeLabel(controlValue ? 1 : 0, label.value[1], label.name)
            "
          />
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
import lables from "./lables.js";

export default {
  props: ["label", "canEdit", "user"],
  data() {
    return {
      labels: lables,
      controlValue: null,
    };
  },
  watch: {
    label: {
      handler() {
        this.labels[this.label.name].value[
          "exDocumentInSystem"
        ].value = this.label.value[1].value;
        this.controlValue = this.label.value[1].value === 1;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs["label-menu"].isActive;
      },
      newVal => {
        if (newVal) {
          this.$emit("open");
        }
        if (!newVal) {
          this.$emit("close");
        }
      },
    );
  },
  methods: {
    getVariantTitleForGroup(label, groupName) {
      const group = this.labels[groupName];
      return group.value[label.name].variants.find(v => v.id === label.value)
        .title;
    },
    getColorForGroup(label, groupName) {
      const defaultColor = "grey";
      const group = this.labels[groupName];
      return group.value[label.name].variants.find(v => v.id === label.value)
        .color
        ? group.value[label.name].variants.find(v => v.id === label.value).color
        : defaultColor;
    },
    getAvailableVariantsForGroup(label, groupName) {
      const group = this.labels[groupName];
      return group.value[label.name].variants.filter(v => v.id !== label.value);
    },
    getControlValueLabel(label, groupName) {
      const controlValue = this.controlValue ? 1 : 0;
      const group = this.labels[groupName];
      const variant = group.value[label.name].variants.find(
        v => v.id === controlValue,
      );
      return variant ? variant.title : "";
    },
    changeLabel(newValue, label, groupName, close) {
      if (close && this.$refs["label-menu"]) {
        this.$refs["label-menu"].isActive = false;
      }
      this.$emit("changeLabel", {
        newValue,
        label,
        groupName,
      });
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  background-color: white;
  height: 216px;
  width: 180px;
}
</style>
